import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/NewsPage.css';

function NewsPage() {
  return (
    <div className="news-page">
      <Header />
      <div className="between-space"></div>
      <Footer />
    </div>
  );
}

export default NewsPage;